import ChevronRightIcon from '@public/icons/chevron-right.svg';
import HomeIcon from '@public/icons/home.svg';
import styled from 'styled-components';

interface BreadCrumbProps {
  upper: string;
  title: string;
}

const BreadCrumbWrapper = styled.section`
  margin-bottom: 30px;

  ul {
    list-style: none;
    display: flex;
    align-items: center;

    li:first-child {
      display: flex;
    }
  }

  .icon {
    margin: 0 10px;
    width: 20px;
    height: 20px;
  }

  .home-icon {
    width: 25px;
    height: 25px;
  }
`;

const PathText = styled.span`
  @media only screen and (max-width: 680px) {
    font-size: 13px;
  }
`;

export default function BreadCrumb(props: BreadCrumbProps) {
  return (
    <BreadCrumbWrapper itemScope itemType="https://schema.org/BreadcrumbList">
      <ul>
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <HomeIcon className="icon home-icon" />
          <meta itemProp="position" content="1" />
        </li>
        <ChevronRightIcon className="icon" />
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <PathText> {props.upper} </PathText>
          <meta itemProp="position" content="2" />
        </li>
        <ChevronRightIcon className="icon" />
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <PathText style={{ color: '#5368F5', fontWeight: 'bold' }}> {props.title} </PathText>
          <meta itemProp="position" content="3" />
        </li>
      </ul>
    </BreadCrumbWrapper>
  );
}
